"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecimalOverflowError = void 0;
class DecimalOverflowError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, DecimalOverflowError.prototype);
        this.name = "DecimalOverflowError";
    }
}
exports.DecimalOverflowError = DecimalOverflowError;
